import React from "react";
import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-solid.css";
import "../../assets/fa-icons/css/sharp-regular.css";
import { IconButton } from "../components/buttons/icon-button";

interface BubbleProps {
  isOpen: boolean;
  onClick?: () => void;
}

const buttonContainer = "flex w-[54px] h-[54px] p-3";
const iconContainer = "flex flex-col w-[30px] h-[30px]";

export const PropertyPalBubble: React.FC<BubbleProps> = ({ isOpen, onClick }) => {
  const icon = isOpen ? (
    <i className="fa-sharp fa-regular fa-xmark text-[28px]" />
  ) : (
    <i className="fa-sharp fa-solid fa-message-lines text-2xl" />
  );
  return (
    <IconButton
      icon={icon}
      ariaLabel={isOpen ? "Close chatbot" : "Open chatbot"}
      onClick={onClick}
      buttonClassName={buttonContainer}
      iconClassName={iconContainer}
      isActive={isOpen}
    />
  );
};
